import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import { Close as CloseIcon, Refresh as RefreshIcon } from '@mui/icons-material';

const PostgresConnectionsModal = ({
  open,
  onClose,
  loading,
  error,
  data,
  scope,
  onScopeChange,
  onRefresh
}) => {
  const handleScopeChange = (_, newScope) => {
    if (newScope != null) {
      onScopeChange(newScope);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h6">PostgreSQL connections</Typography>
          <Button onClick={onClose} startIcon={<CloseIcon />} size="small">
            Close
          </Button>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', mb: 2 }}>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={scope}
            onChange={handleScopeChange}
            disabled={loading}
          >
            <ToggleButton value="application">
              <Tooltip title="Connections to the SyncTrack database only (AsroSync apps)">
                <span>Application (SyncTrack)</span>
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="server">
              <Tooltip title="All connections on the Postgres server (every database)">
                <span>Full server</span>
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>

          <Button
            size="small"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
            disabled={loading}
          >
            Refresh
          </Button>
        </Box>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {!loading && error && (
          <Alert severity="error">{error}</Alert>
        )}

        {!loading && !error && data && (
          <Box
            component="pre"
            sx={{
              m: 0,
              p: 2,
              borderRadius: 1,
              bgcolor: 'rgba(0,0,0,0.04)',
              overflow: 'auto',
              maxHeight: '65vh',
              fontSize: '0.75rem',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }}
          >
            {JSON.stringify(data, null, 2)}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PostgresConnectionsModal;
